import { render, staticRenderFns } from "./FeaturedVideos.vue?vue&type=template&id=1bae83cf"
import script from "./FeaturedVideos.vue?vue&type=script&lang=js"
export * from "./FeaturedVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports